/**
 * Training Mode sidebar toggle — rendered at the bottom of the sidebar,
 * directly above the user/role block (spec §1A).
 *
 * Style: 44×24 toggle, #dddddd OFF, #2563eb ON. Label "Training Mode"
 * in 13px 500 weight. Status line below.
 */
import { useTraining } from "@/lib/trainingContext";
import { GraduationCap } from "lucide-react";

export default function TrainingModeToggle() {
  const { enabled, setEnabled } = useTraining();

  return (
    <div
      data-testid="training-mode-toggle-row"
      data-enabled={enabled ? "true" : "false"}
      style={{
        borderTop: "0.5px solid #eeeeee",
        padding: "10px 14px",
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <GraduationCap style={{ width: 16, height: 16, color: "#555" }} aria-hidden />
        <div style={{ flex: 1, fontSize: 13, fontWeight: 500, color: "var(--text-primary)" }}>
          Training Mode
        </div>
        <button
          type="button"
          onClick={() => setEnabled(!enabled)}
          data-testid="training-mode-toggle"
          aria-pressed={enabled}
          aria-label="Toggle Training Mode"
          style={{
            width: 44,
            height: 24,
            borderRadius: 12,
            background: enabled ? "#2563eb" : "#dddddd",
            border: "none",
            cursor: "pointer",
            position: "relative",
            transition: "background-color 0.2s ease",
            padding: 0,
            flexShrink: 0,
          }}
        >
          <span
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              background: "#fff",
              position: "absolute",
              top: 2,
              left: enabled ? 22 : 2,
              transition: "left 0.2s ease",
              boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
            }}
          />
        </button>
      </div>
      {!enabled ? (
        <div style={{ fontSize: 10, color: "#888888", paddingLeft: 26 }}>
          Learn any feature interactively
        </div>
      ) : (
        <div
          style={{
            fontSize: 10,
            color: "#1D9E75",
            paddingLeft: 26,
            display: "flex",
            alignItems: "center",
            gap: 5,
          }}
          data-testid="training-mode-active-indicator"
        >
          <span
            aria-hidden
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#1D9E75",
              animation: "trainingPulse 1.2s infinite",
              display: "inline-block",
            }}
          />
          Training active — AI trainer ready
          <style>{`@keyframes trainingPulse { 0%,100% { opacity: 1; } 50% { opacity: 0.3; } }`}</style>
        </div>
      )}
    </div>
  );
}
